import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';

const RotateIcon = ({ className, size }) => {
  if (size === 'small') {
    return (
      <svg
        className={getClassName(className)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        id="icon"
      >
        <path
          d="M1.25 17.5V10a1.252 1.252 0 0 1 1.25 -1.25H10a1.252 1.252 0 0 1 1.25 1.25V17.5a1.252 1.252 0 0 1 -1.25 1.25H2.5A1.252 1.252 0 0 1 1.25 17.5ZM2.5 10 2.499 17.5H10V10Z"
          transform="translate(0 0)"
        />
        <path
          d="M10.625 1.25l0.881 0.881L9.894 3.75H13.125a4.38 4.38 0 0 1 4.375 4.375v3.125H16.25V8.125a3.128 3.128 0 0 0 -3.125 -3.125H9.894l1.613 1.618L10.625 7.5 7.5 4.375Z"
          transform="translate(0 0)"
        />
      </svg>
    );
  }
  return (
    <svg
      className={getClassName(className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="icon"
    >
      <path
        d="M1.5 21V12a1.502 1.502 0 0 1 1.5 -1.5H12a1.502 1.502 0 0 1 1.5 1.5V21a1.502 1.502 0 0 1 -1.5 1.5H3A1.502 1.502 0 0 1 1.5 21ZM3 12 2.999 21H12V12Z"
        transform="translate(0 0)"
      />
      <path
        d="M12.75 1.5l1.057 1.057L11.873 4.5H15.75a5.256 5.256 0 0 1 5.25 5.25v3.75H19.5V9.75a3.754 3.754 0 0 0 -3.75 -3.75H11.873l1.935 1.942L12.75 9 9 5.25Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};

RotateIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

RotateIcon.defaultProps = {
  size: 'small',
  className: 'w-5 h-5',
};

export default RotateIcon;
